<style lang="scss">

</style>

<template>
  <section>
    <p>Please enter the details for the {{ $options.filters.term('prisoner')}} ({{prisonerNumber}})) at your establishment.</p>

    <validation-observer ref="prisonerInfoForm">
      <validation-provider #default="{ errors }" name="First name" rules="required">
        <label>{{ $options.filters.term('prisoner') | capEachWord }} first name</label>
        <b-form-input @input="setVuexProp($event, 'prisoner_firstname')" placeholder="Enter first name" class="mb-2"
                       :state="errors.length > 0 ? false:null"
                       :value="offsiteContact.prisoner_firstname"/>
        <small class="text-danger d-block my-1">{{ errors[0] }}</small>
      </validation-provider>

      <validation-provider #default="{ errors }" name="Last name" rules="required">
        <label>{{ $options.filters.term('prisoner') | capEachWord }} last name</label>
        <b-form-input @input="setVuexProp($event, 'prisoner_lastname')" placeholder="Enter last name" class="mb-2"
                      :state="errors.length > 0 ? false:null"
                      :value="offsiteContact.prisoner_lastname"/>
        <small class="text-danger d-block my-1">{{ errors[0] }}</small>
      </validation-provider>

      <section class="d-flex full-width justify-content-end">
<!--        <button class="btn btn-danger mt-2 mr-2" @click="setStage(1)">Back</button>-->
        <button class="btn btn-primary mt-1" @click="prisonerInfoStageValidation()">Next</button>
      </section>
    </validation-observer>
  </section>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {},
  components: {},
  computed: {
    ...mapState({
      prisonerNumber: state => state.booking.offsiteBooking.prisonerNumber,
      offsiteContact: state => state.booking.offsiteContact,
      sites: state => state.booking.offsiteEstablishments,
      stage: state => state.booking.offsiteStage,
    }),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    setStage(number) {
      this.$store.commit('booking/SET_OFFSITE_STAGE', number);
    },
    prisonerInfoStageValidation() {
      this.$refs.prisonerInfoForm.validate().then(success => {
        if (success) {
          this.setStage(3);
        }
      });
    },
    setVuexProp(e, prop) {
      this.$store.commit('booking/SET_OFFSITE_CONTACT_ITEM', {prop, value: e});
    },
  },
};
</script>
